import {Routes} from '@angular/router';

const VARIANT_REDIRECT_MAPPINGS: Array<[string, string]> = [
  ['variant/about', 'covid19/about'],
  ['variant/assay-details', 'covid19/assays'],
  ['variant/monkeypox', 'mpox'],
  ['variant/trace/variant-data', 'covid19/variant/trace/variant-data'],
  ['variant/trace/assay', 'covid19/variant/trace/assay'],
  ['variant/trace/reagent', 'covid19/variant/trace/reagent'],
  ['variant/trace/mutation', 'covid19/variant/trace/mutation'],
  ['variant/trace/about', 'covid19/variant/trace/about'],
  ['variant/animal-models/summary', 'covid19/animal-models/summary'],
  ['variant/animal-models/sam-field-guide', 'covid19/animal-models/sam-field-guide'],
  ['variant/animal-models/nhp-field-guide', 'covid19/animal-models/nhp-field-guide'],
  ['variant/animal-models/activ-resources', 'covid19/animal-models/activ-resources'],
  ['variant/animal-models/nhp/:id', 'covid19/animal-models/nhp/:id'],
  ['variant/animal-models/nhp-details', 'covid19/animal-models/nhp-details'],
  ['variant/animal-models/small-animals/:id', 'covid19/animal-models/small-animals/:id'],
  ['variant/assays', 'covid19/variant/assays'],
  ['variant/assays/:id/:assay', 'covid19/variant/assays/:id/:assay'],
  ['variant/activity', 'covid19/variant/activity'],
  ['variant/activity/:variant', 'covid19/variant/activity/:variant'],
  ['variant/summary', 'covid19/variant/summary'],
  ['variant/datasets', 'covid19/variant/datasets'],
  ['variant/heterologous-booster', 'covid19/variant/heterologous-booster'],
  ['variant/multivalent-booster', 'covid19/variant/multivalent-booster'],
  ['variant/variant-glossary', 'covid19/variant/glossary'],
  ['variant/in-vivo', 'covid19/variant/in-vivo'],
  ['variant/real-world-evidence', 'covid19/variant/real-world-evidence'],
  ['variant/related-resources', 'covid19/variant/related-resources'],
  ['variant/variant-about', 'covid19/variant/about'],
  ['variant/therapeutic-glossary', 'covid19/therapeutic-glossary'],
  ['variant/curveclasses', 'covid19/curveclasses'],
  ['variant/databrowser', 'covid19/databrowser'],
  ['variant/GS-441524', 'covid19/GS-441524']
];

export const LEGACY_REDIRECTS: Routes = [
  {path: 'rwd-training', redirectTo: 'rwd', pathMatch: 'full'},
  {path: 'variant', redirectTo: 'home', pathMatch: 'full'},
  ...VARIANT_REDIRECT_MAPPINGS.map(([from, to]) => ({
    path: from,
    redirectTo: to,
    pathMatch: 'full' as const
  }))
];
